import React from 'react';
import { useGridApiContext } from '@mui/x-data-grid';
import { UserRoleSelect } from '@/components/views/SettingsView/BrokerageUsersTable/UserRoleSelect';

/**
 * Edits a row's role from the CRM's roles (UserRoleSelect, as in the user drawers), open as
 * soon as the cell is clicked. Picking one saves the cell.
 */
export const RoleEditCell = ({ id, field, value }) => {
	const apiRef = useGridApiContext();

	const handleChange = async (event) => {
		await apiRef.current.setEditCellValue({ id, field, value: event.target.value });
		apiRef.current.stopCellEditMode({ id, field });
	};

	return (
		<UserRoleSelect
			value={value ?? ''}
			includeAllOption={false}
			onChange={handleChange}
			defaultOpen
		/>
	);
};
